// Note: For Azure Static Apps, environment variables are not available at runtime
// So we use build-time environment variables or hardcoded values

const API_CONFIG = {
  // Base API URL - change this for different environments
  BASE_URL: (process.env.REACT_APP_API_URL || (
    process.env.NODE_ENV === 'development'
      ? 'http://localhost:3001/api'
      : 'https://api.employeeconnect.nsieng.com/api'
  )),
  // Must match the exact Entra ID (Azure AD) SPA redirect URI you registered.
  FRONTEND_URL: (process.env.REACT_APP_FRONTEND_URL || (
    process.env.NODE_ENV === 'development'
      ? 'http://localhost:3000/'
      : 'https://employeeconnect.nsieng.com'
  )),
};

const normalizeBaseUrl = (raw) => {
  if (!raw) return '';
  return String(raw).trim().replace(/\/+$/, '');
};

const ensureApiPrefix = (path) => {
  const p = String(path || '');
  const withLeadingSlash = p.startsWith('/') ? p : `/${p}`;
  return withLeadingSlash.startsWith('/api/') || withLeadingSlash === '/api'
    ? withLeadingSlash
    : `/api${withLeadingSlash}`;
};

export const buildApiUrl = (endpoint) => {
  const base = normalizeBaseUrl(API_CONFIG.BASE_URL);
  const path = ensureApiPrefix(endpoint);

  // Allow BASE_URL to be either:
  // - a full origin (e.g. "http://localhost:3001" or "http://localhost:3001/api")
  // - a proxy path (e.g. "/api")
  if (!base) return path;

  // If BASE_URL already ends with "/api", avoid doubling.
  const baseNoApi = base.endsWith('/api') ? base.slice(0, -4) : base;

  return `${baseNoApi}${path}`;
};

export default API_CONFIG;